module.exports = __webpack_public_path__ + "static/media/TWYG.3747af99.png";